module.exports = "/virtual-football-league/img/amblems/right/logos/Juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Juventus.png
// module id = 2204
// module chunks = 4